export default "__VITE_ASSET__CXbxWbM9__"